import { createContext, useContext, useState } from 'react';
import { ref, get } from 'firebase/database';
import { db } from '../config/firebase';

const ShoppingContext = createContext();

export const useShoppingCart = () => {
  return useContext(ShoppingContext);
};

export const ShoppingProvider = ({ children }) => {
  const [cart, setCart] = useState({});

  const addToCart = (product) => {
    setCart((prev) => ({
      ...prev,
      [product.id]: (prev[product.id] || 0) + 1,
    }));
  };

  const removeFromCart = (product) => {
    setCart((prev) => {
      const newCart = { ...prev };
      if (newCart[product.id] > 1) {
        newCart[product.id]--;
      } else {
        delete newCart[product.id];
      }
      return newCart;
    });
  };

  const clearCart = () => {
    setCart({});
  };

  const getCartTotal = async () => {
    try {
      const productsRef = ref(db, 'products/products');
      const snapshot = await get(productsRef);
      if (snapshot.exists()) {
        const products = snapshot.val();
        return Object.entries(cart).reduce((total, [productId, quantity]) => {
          const product = Object.values(products)
            .flat()
            .find((p) => p.id === productId);
          return total + (product?.price || 0) * quantity;
        }, 0);
      }
      return 0;
    } catch (error) {
      console.error('Error calculating cart total:', error);
      return 0;
    }
  };

  return (
    <ShoppingContext.Provider
      value={{ cart, addToCart, removeFromCart, clearCart, getCartTotal }}
    >
      {children}
    </ShoppingContext.Provider>
  );
};
